/**
* @use Page Not Found Handling
* @author Ghanshyam Tank<ghanshyam.tank@softwebsolutions.com>
* @return html
* */
import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
	templateUrl: '/templates/site/partials/pagenotfound.html'
})
export class PageNotFoundComponent {
	constructor() {
	}
}